export const roundToTwoDecimal = (number: number) => {
  const rounded = Math.round((number + Number.EPSILON) * 100) / 100;
  return rounded ? rounded : number;
};
